<template>
  <div class="bg-white">
    <CoverPage />
    <div class="">
      <div class="">
        <!-- bg-caregiverimg -->
        <div class="lg:px-12 md:px-12 px-4">
          <div>
            <OurServices />
          </div>

          <OurServiceCard />
          <MedicalCondition />
          <MedicalConditionBox />
          <CaseStudies />
          <TellusStory />
        </div>
        <div class="lg:px-0 md:px-0 px-4">
          <Testimonials />
        </div>
        <!-- <Membership /> -->
      </div>
      <div class="lg:px-0 md:px-0 px-6 mob-hidden">
        <div class="md:hidden lg:hidden block">
          <div class="">
            <OurServices />
            <OurServiceCard />
          </div>
          <MedicalCondition />
          <MedicalConditionBox />
          <CaseStudies />
          <Testimonials />
          <TellusStory />

          <!-- <Membership /> -->
        </div>
      </div>
    </div>
    <LatestGrid />
    <div class="px-4 mt-12">
      <FAQ />
    </div>

    <div class="bge3ceff-opa rounded-t-5555 mt-12">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import TellusStory from "./components/TellusStory.vue";
import CoverPage from "./components/CoverPage.vue";
import OurServices from "./components/OurServices.vue";
import MedicalCondition from "./components/MedicalCondition.vue";
import CaseStudies from "./components/CaseStudies.vue";
import Testimonials from "./components/Testimonials.vue";
import Membership from "./components/Membership.vue";
import FAQ from "./components/FAQ.vue";
import LatestGrid from "./components/LatestGrid.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
import OurServiceCard from "./components/OurServiceCard";
import MedicalConditionBox from "./components/MedicalConditionBox";
export default {
  components: {
    CoverPage,
    OurServices,
    MedicalCondition,
    CaseStudies,
    Testimonials,
    Membership,
    FAQ,
    LatestGrid,
    DownloadApp,
    Footer,
    TellusStory,
    OurServiceCard,
    MedicalConditionBox,
  },
  metaInfo: {
    title: "Empowering Caregivers - Caregiver Saathi",
    meta: [
      {
        name: "keyword",
        content:
          "Caregiver caregiving, agencies for caregivers,agencies for home care,assisted home care services,home care agency,home care for elderly,home care for seniors,at home nurse care,at home senior care services,care for the caregiver program,caregiver burden,wellness,well-being,health and well-being,mental health,physical health,psychological wellbeing,caregiver needs,caregiver burnout,caregiver stress,family caregiver,caregiver companion,respite care,attendant,patient support,nursing services,caregiving services,caregiver websites,Caregiving training,Caregiver support,Caregiving for specific needs,Caregiving training near me,Caregivers for seniors,Caregiving agencies,caregiving agencies in Mumbai,Caregiving and compassionate reasons,Caregiving for healthcare professionals,counselling,therapy,coaching,caregiver coaching,palliative care,caregiving support for cancer patient,attendant for dementia patient,helpline for caregiving,grief support group,volunteering,volunteering opportunities in India,grief management,employee well-being,corporate services,online forum for caregiver,community for caregivers,bhavana Issar,online learning,care management,caregiving courses,",
      },
      {
        name: "description",
        content:
          "Caregiver Saathi offers couselling , advisory & homecare services for caregivers seeking help for patients with illness like cancer, dementia, kidney failure",
      },
    ],
  },
  methods: {
    handleregister() {
      this.$router.push({ name: "register" });
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
<style scoped></style>
